var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-body"},[_c('div',{staticClass:"l-menu-live",on:{"click":function($event){return _vm.taskEvent()}}},[_c('div',[_vm._v("直播指导表现")])]),(_vm.isRead)?_c('div',{staticClass:"l-red"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }